// "Delivery address same as billing" checkbox: hides the separate delivery
// fields while checked (the default), reveals them when unchecked.

document.addEventListener('change', function (event) {
  var checkbox = event.target.closest('[data-checkout-toggle]')
  if (!checkbox) return

  var target = document.getElementById(checkbox.dataset.checkoutToggle)
  if (target) target.hidden = checkbox.checked
})
